import Vue from "vue";

let request = (url, method, data) => {
    if(data){
		Object.keys(data).forEach(item => {
            if(typeof(data[item]) == undefined || data[item]==null) {
			delete data[item];
        }
		})
	}else {
		data = {};
	}
	return Vue.prototype.$axios({
        url: url,
        method: method,
        data: {
            ...data,
            userid: window.localStorage.getItem("userid"),
            token: window.localStorage.getItem("token")
        },
        dataType: 'json',
    }).then(res => {
        if (res[1].status == 200) {
            if(res[1].data.flag=='false' && res[1].data.info=='未登录'){
                console.log("fuck");
            }
            return res[1]
        } else {
            throw res[1].data
        }
    }).catch(parmas => {
        switch (parmas.code) {
            case 401:
                break
            default:
                return Promise.reject()
        }
    })
}

export default request
